import { takeUntil } from 'rxjs/operators';

import { requestStream } from '@swf/core/api/requestStream';
import type { EffectParams, ModelConfig, Slicer } from '@swf/core/store';
import { select } from '@swf/core/store';
import type { ChestInventoryState } from '@swf/core/types/ChestInventory';
import { logout } from '@swf/core/utils/actions';

interface ChestInventoryModel extends ModelConfig<ChestInventoryState> {
  reducers: typeof reducers;
  selectors: typeof selectors;
  effects: typeof effects;
}

const defaultState = {
  subscriptions: {}
};

const reducers = {
  set: (state: ChestInventoryState, payload: ChestInventoryState) => ({ ...state, ...payload }),
  'session/clear': (): ChestInventoryState => defaultState
};

const selectors = (slice: Slicer<ChestInventoryState>) => ({
  get() {
    return slice((state) => state || {});
  },
  hideChests() {
    return slice((state) => !!state.settings?.hideChests);
  }
});

const effects = {
  async fetchChestInventory(payload: undefined, { dispatch, rootState, actions }: EffectParams) {
    const options = select.cms.getRequestOptions(rootState);
    const onLogout = logout(actions) as NonNullable<ReturnType<typeof logout>>;

    requestStream<ChestInventoryState>({
      ...options,
      service: '/api/v1-preview/chests'
    })
      .pipe(takeUntil(onLogout))
      .subscribe((update) => dispatch.chestInventory.set(update));
  }
};

const model: ChestInventoryModel = {
  state: defaultState,
  reducers,
  selectors,
  effects
};

export default model;
